module.exports = __webpack_public_path__ + "img/btc.edae64fc.svg";